import axios from "axios";
import axiosRetry from "axios-retry";
import getSource from "./get-source";

export default async function apiRequest(
  url,
  data,
  isPostRequest,
  _isEventRequest,
  isPatchRequest,
  sendSourceId,
  sendeUserId,
  _isOldEnvironment,
  _unused,
  params,
  isSourceIdUnwanted,
  customHeadersToOverride,
  customConfig
) {
  const headers = {
    "Content-Type": "application/json"
  }

  const instance = axios.create({
    timeout: 1000 * 60 * 1,
    headers: { ...headers, ...customHeadersToOverride }
  });
  /**
   * Reducing number of retries to 1
   */
  axiosRetry(instance, { retries: 1 });
  /* axiosRetry(axios, {
    retryDelay: retryCount => 1 * retryCount * 1000
  }); */
  axiosRetry(instance, { retryDelay: 2 * 1000 });
  try {
    // TODO FIX THIS IF LADDER
    let response;
    if (isPatchRequest) {
      const sourceData = await getSource();
      if (sendSourceId) {
        data.source_user_id = sourceData.source_user_id;
      }
      if (sendeUserId) {
        data.source_user_id = sourceData.e_user_id;
      }
      data.source_id = sourceData.source_id;
      response = await instance.patch(url, data);
    } else if (isPostRequest) {
      const sourceData = await getSource();
      if (sendSourceId) {
        data.source_user_id = sourceData.source_user_id;
      }
      if (sendeUserId) {
        data.source_user_id = sourceData.e_user_id;
      }
      if (!isSourceIdUnwanted)
        data.source_id = sourceData.source_id;

      if (customConfig)
        response = await instance.post(url, data, customConfig);

      else
        response = await instance.post(url, data);
    } else {
      if (!params)
        response = await instance.get(url);
      else
        response = await instance.get(url, { params: params });
    }
    // TODO fix the HACK post release
    if (!response.data) {
      response.data = {};
    }
    response.data.statusCode = response.status;
    return response.data;
  } catch (error) {
    if (error) {
      error.apiResponse = "failed";
      error.statusCode = error.response ? error.response.status : "";
    }
    return error;
  }
}
